import { ReactNode } from "react";
import { ExploreProps } from "./ExploreSideBarContent";
import { ExploreSideBar } from "./ExploreSideBar";
import styled from "@emotion/styled";
import { BaseEntryResultType } from "@kaltura/mediaspace-shared-types";

interface ExploreSideBarLayoutProps extends Omit<ExploreProps, "searchResult"> {
    className?: string;
    children: ReactNode;
    // Same prop as in ExploreProps, but make it optional
    searchResult?: BaseEntryResultType;
}

/**
 * Layout for displaying content (the "children" prop) from the left side
 * and the explore bar from the right side,
 * including all variations for different breakpoints.
 */
export const ExploreSideBarLayout = ({
    className,
    children,
    searchResult,
    ...exploreProps
}: ExploreSideBarLayoutProps) => {
    return (
        <StyledOuterContainer className={className}>
            <StyledContentContainer isOpenExplore={!!searchResult}>{children}</StyledContentContainer>

            {searchResult && <ExploreSideBar searchResult={searchResult} {...exploreProps} />}
        </StyledOuterContainer>
    );
};

const StyledOuterContainer = styled("div")({
    display: "flex",
});

const StyledContentContainer = styled("div")<{ isOpenExplore: boolean }>(({ theme, isOpenExplore }) => ({
    position: "relative",
    flexGrow: 1,
    minWidth: 0,
    display: "block",
    [theme.breakpoints.down("md")]: {
        display: isOpenExplore ? "none" : "block",
    },
}));
